/**
 * Referral invitee discount percentage
 * @type {number}
 */
export const DISCOUNT_AMOUNT = 0.1;
